'use client'

import React from "react"; 
import { ReactNode } from "react";
import { StyleSheetManager, ThemeProvider } from "styled-components";
import GlobalStyles from "../config/theme.config";
import DefaultTheme from "../themes/default.theme";
// import { ContentfulLivePreviewProvider } from "@contentful/live-preview/react";
import isPropValid from "@emotion/is-prop-valid";
import { getLocale } from "@/config/app.config";
// import ContextProvider from "@/context/ContextProvider";
import { FormContextProvider } from "@/context/FormContextProvider";
import dynamic from "next/dynamic";
import OneTrust from "@/client/foundations/OneTrust";

/***
 *
 * @file app/providers.tsx
 * @description Providers is used to available provider(s).
 * @author Naveen Kumar
 * @organization Ingka Center
 * @since 25 Feb 2024
 *
 */

/** 
 * 
 * https://www.contentful.com/developers/docs/tutorials/general/live-preview/#set-up-live-preview
  <ContentfulLivePreviewProvider
    locale="set-your-locale-here" // Required: allows you to set the locale once and have it reused throughout the preview.
    enableInspectorMode={false} // Optional: allows you to toggle inspector mode which is on by default.
    enableLiveUpdates={false} // Optional: allows you to toggle live updates which are on by default.
    targetOrigin="https://app.contentful.com" // Optional: allows you to configure the allowed host(s) of live preview (default: ['https://app.contentful.com', 'https://app.eu.contentful.com'])
    debugMode={false} // Optional: allows you to toggle debug mode which is off by default.
  >
  */


// This implements the default behavior from styled-components v5
const shouldForwardProp = (propName: string, target: unknown) => {
  if (typeof target === "string") {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName);
  }
  // For other elements, forward all props
  return true;
}

type T_Props = {
  children: ReactNode,
  scriptId: string,
  draftMode?: boolean,
  locale?: string
}

// const OneTrust = dynamic(() => import("@/client/foundations/OneTrust"), {
//   ssr: false, // optional: disable SSR if the component depends on `window`
// });

const Providers = ({ children, scriptId, draftMode = false, locale = getLocale() }: T_Props) => {

  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      {/* <ContentfulLivePreviewProvider
        locale={locale}
        enableInspectorMode={draftMode}
        enableLiveUpdates={draftMode}
        targetOrigin="https://app.contentful.com"
        debugMode={draftMode}
      > */}
      {/* OneTrust Cookies Consent Notice */}
      <OneTrust scriptId={scriptId} />
      <ThemeProvider theme={DefaultTheme}>
        <GlobalStyles />
        <FormContextProvider>
          {children}
        </FormContextProvider>
      </ThemeProvider>
      {/* </ContentfulLivePreviewProvider> */}
    </StyleSheetManager>
  )
}

export default Providers;